/* @ngInject */
const mySaleCreateForm = (
  labels,
  toaster,
  $$sale,
  $$railway,
  $$area,
  $$wagon
) => {
  return {
    restrict: 'E',
    scope: {
      sale: '=mySale',
      oldValue: '=myOldValue',
      mySearchedWagons: '=mySearchedWagons',
      id: '@myId',
      myAreaSearchdata: '=',
      myRailwaySearchdata: '=',
    },

    template: require('./mySaleCreateForm.html'),

    /* @ngInject */
    controller: ($scope) => {
      $scope.wagonIds = []

      $scope.createSale = async (_sale, wagonIds) => {
        try {
          const response = await $$sale.request.save(_sale, wagonIds)
          toaster.message(labels.sale.log.save.success)
          $$sale.go.details(response.id)
        } catch (error) {
          toaster.error(error)
        }
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default mySaleCreateForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/directives/forms/mySaleCreateForm.js